export default __webpack_public_path__ + "static/media/product_attributes_csv.0dae04df.csv";